export const AVERAGE_SUBJECTS_VALUE = 'Общая по всем предметам';
export const MAX_CHECKBOX_VALUES = 5;

export const CHART_LINE_COLORS = [
  '#E44D53', // По всем предметам
  '#BB58D4',
  '#9E90FB',
  '#068382',
  '#597BEC',
  '#00C512',
];

export const CHART_LABEL_COLORS = [
  '#CE1D2A', // По всем предметам
  '#A23AB9',
  '#734AE5',
  '#047575',
  '#3D5DE0',
  '#007B1A',
];
